import React, {Component} from 'react'

import {zip} from '../../utils'

import Input from '../Input'

import './styles.css'

class ZipAnswers extends Component {
  state = {
    state: undefined,
  }

  componentWillMount() {
    this.setState({state: zip.getState(this.props.answer)})
  }

  componentWillReceiveProps(nextProps) {
    this.setState({state: zip.getState(nextProps.answer)})
  }


  render() {
    const {answer, onChange} = this.props
    const {state} = this.state

    return (
      <div className="zip-answer">
        <div className="zip-answer-position">
          <Input
            value={answer || ""}
            className="zip-answer-input"
            placeholder="Zip Code"
            onChange={onChange}
          />
          {state && <div className="zip-answer-state">{state}</div>}
        </div>
      </div>
    )
  }
}

export default ZipAnswers



// WEBPACK FOOTER //
// ./src/components/Question/ZipAnswers.js